import {coreAgent} from "../../app/api/agent";
import {ContractDto} from "./dtos/ContractDto";


export const getContractsRequest = () =>
  coreAgent.getRequest<ContractDto[]>(`contracts`);
